/**
 * @file アコーディオン
 */
'use strict';
// utility class
import ApplyClass from '../util/_apply-class';
import CartProductTemplate from '../template/_cart-product';
import RemoveCartOptionView from './_remove-cart-option-view';


/**
 * @classname AnchorToggleView
 * @classdesc アコーディオン
 */
export default class AnchorToggleView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('AnchorToggleView.constructor');
		this._$e = $e;
		if($(window).width() < 768){
			this._$target = this._$e.closest('.list-item').find('.list');
			this._$e.on('click', () => {this.onClick();});
		}
	};


	/**
	 * クリックのコールバック
	 *
	 * @memberof FormSubmitView
	 * @return {undefined}
	 */
	onClick() {
		console.log('AnchorToggleView.onClick');
		if(this._$e.hasClass('open')){
			this._$target.slideUp();
			this._$e.removeClass('open');
		}else{
			this._$target.slideDown();
			this._$e.addClass('open');
		}
	};
}
